import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  display: flex;
  background: ${({ theme }) => theme.color.white};
  padding: ${rem(16)} ${rem(18)};
  gap: ${rem(12)};
  cursor: pointer;
  align-items: center;
`;

export const RightArea = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  gap: ${rem(10)};
  align-items: start;
  justify-content: space-between;
  ${({ theme }) => theme.media.fold`
    gap: ${rem(8)};
  `}
`;

export const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
`;
